module.exports = __webpack_public_path__ + "img/product-placeholder-19.f6e6611.png";